const WORKER_URL =
  process.env.NEXT_PUBLIC_TOOLS_AI_URL || 'https://tools-ai-api.superpowerresume.com';

export interface AIJDAnalysis {
  requiredSkills: string[];
  preferredSkills: string[];
  experience: { years: string; field: string }[];
  education: { level: string; field: string }[];
  responsibilities: string[];
  seniorityLevel: string;
  companyInsights: string;
}

export interface AIATSResult {
  score: number;
  matchedKeywords: { keyword: string; context: string }[];
  missingKeywords: string[];
  categoryBreakdown: { category: string; matched: number; total: number }[];
  suggestions: string[];
}

export async function analyzeJDWithAI(
  jobDescription: string,
): Promise<AIJDAnalysis> {
  const res = await fetch(`${WORKER_URL}/analyze-jd`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ jobDescription }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error((err as { error?: string }).error || `HTTP ${res.status}`);
  }

  return res.json() as Promise<AIJDAnalysis>;
}

export async function atsCheckWithAI(
  resume: string,
  jobDescription: string,
): Promise<AIATSResult> {
  const res = await fetch(`${WORKER_URL}/ats-check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resume, jobDescription }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error((err as { error?: string }).error || `HTTP ${res.status}`);
  }

  return res.json() as Promise<AIATSResult>;
}
